import { useOne } from '@refinedev/core';
import { Descriptions, Spin, Alert } from 'antd';
import { formatDate, formatDateTime } from '@viq-admin/ui';
import { Conference } from '../../api/types';

export function ConferenceOverview({ conferenceId }: { conferenceId: string }) {
  const { query, result } = useOne<Conference>({
    resource: 'conferences',
    id: conferenceId,
  });

  if (query.isLoading) return <Spin />;
  if (query.error) {
    return (
      <Alert
        type="error"
        message="Couldn't load conference"
        description={query.error.message}
      />
    );
  }
  const c = result;
  if (!c) return null;

  return (
    <Descriptions column={1} bordered>
      <Descriptions.Item label="Name">{c.name}</Descriptions.Item>
      <Descriptions.Item label="Location">{c.location ?? '—'}</Descriptions.Item>
      <Descriptions.Item label="Starts">
        {formatDate(c.startDate)}
      </Descriptions.Item>
      <Descriptions.Item label="Ends">
        {formatDate(c.endDate)}
      </Descriptions.Item>
      <Descriptions.Item label="Created">
        {formatDateTime(c.createdAt)}
      </Descriptions.Item>
      <Descriptions.Item label="Updated">
        {formatDateTime(c.updatedAt)}
      </Descriptions.Item>
    </Descriptions>
  );
}
